import React from "react";
import { Parser, ProcessNodeDefinitions } from "html-to-react";
import { Link } from "react-router-dom";
import { GET_CONFIG } from "@app/util";

export interface IHtmlRenderComponentProps {
  html: string;
}

const getEssentialUrl = (url: string) => {
  const splittedUrl = url.split(".");
  const splittedUrlLength = url.split(".").length;

  return splittedUrlLength > 1
    ? `${splittedUrl[splittedUrlLength - 2]}.${splittedUrl[splittedUrlLength - 1]}`
    : `${splittedUrl[splittedUrlLength - 1]}`;
};

const processingInstructions = [
  {
    shouldProcessNode: (node: any) => {
      return node.name && node.name === "a";
    },
    processNode: (node: any, children: any, index: number) => {
      if (node.attribs.href && node.attribs.href !== "") {
        const currentBaseUrl = GET_CONFIG.CLIENT_URL;
        const checkIfUrlStartsWithSlash = node.attribs.href[0] === "/";
        if (checkIfUrlStartsWithSlash) {
          return (
            <Link key={index} to={node.attribs.href}>
              {children}
            </Link>
          );
        }

        const checkIfUrlHasHttp = node.attribs.href.match(/https|http/gi);
        const urlWithoutHttp = checkIfUrlHasHttp
          ? node.attribs.href.replace("https://", "").replace("http://", "")
          : node.attribs.href;

        const firstPartOfUrl = urlWithoutHttp.split("/")[0];
        const urlIsSameAsBase = getEssentialUrl(firstPartOfUrl) === getEssentialUrl(currentBaseUrl);

        if (urlIsSameAsBase) {
          const removedBaseUrl = urlWithoutHttp.replace(firstPartOfUrl, "");

          return (
            <Link key={index} to={removedBaseUrl}>
              {children}
            </Link>
          );
        }

        return React.createElement(
          "a",
          { key: index, href: node.attribs.href, target: "_blank", rel: "noreferrer" },
          children
        );
      }

      if (node.attribs.href === "" || !node.attribs.href) {
        return <React.Fragment>{children}</React.Fragment>;
      }

      return node;
    }
  },
  {
    // Anything else
    shouldProcessNode: () => true,
    processNode: ProcessNodeDefinitions().processDefaultNode
  }
];

const fixAnchorParentheses = (html: string) => {
  const findDoubleParentheseRegex = /<a href="".[^>]*"">|<a href="""">/gi;
  const foundErrors = html.match(findDoubleParentheseRegex);
  if (foundErrors) {
    let editedHtml = html;
    const fixedErrors = foundErrors.map((item) => item.replace(/""/gi, `"`));
    fixedErrors.forEach((item, index) => {
      editedHtml = editedHtml.replace(foundErrors[index], item);
    });

    return editedHtml;
  }

  return html;
};

const HtmlRenderComponent = (props: IHtmlRenderComponentProps) => {
  return (
    <React.Fragment>
      {Parser().parseWithInstructions(fixAnchorParentheses(props.html), () => true, processingInstructions)}
    </React.Fragment>
  );
};

export { HtmlRenderComponent };
